import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import history from '../containers/Utils/history';
// import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import AppointmentReducer from '../containers/Appointment/reducer';
import ChatReducer from '../containers/chat/reducers';
import SupportReducer from '../containers/SupportChat/reducers';
import PatientInteractionReducer from '../containers/PatientInteractions/reducers';
import globalReducer from '../containers/globalReducer';
import encounterNote from '../containers/EncounterNote/slice';
import patientOutcomes from '../containers/PatientOutcomes/slice';
import rxOrders from '../containers/RxOrders/slice';
import rxMedications from '../containers/RxMedications/slice';
import patient from '../containers/Patient/patient-slice';
import apptService from '../containers/AppointmentService/slice';
import secureShare from '../containers/SecureShare/slice';
import homeReducer from '../containers/Home/home-slice';
import workflow from '../containers/workflow/workflow-slice';

const rootReducer = combineReducers({
  router: connectRouter(history),
  Appointment: AppointmentReducer,
  chat: ChatReducer,
  support: SupportReducer,
  ptInteractions: PatientInteractionReducer,
  global: globalReducer,
  encounterNote,
  patientOutcomes,
  rxOrders,
  rxMedications,
  patient,
  apptService,
  secureShare,
  home: homeReducer,
  workflow,
});

const appReducer = (state, action) => {
  if (action.type === '__RESET_STORE__') {
    state = undefined;
    // return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};
export default appReducer;
